import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Calculatrice de densite (masse / volume)";
const DESCRIPTION =
  "Calculatrice de densite (masse / volume). Calculateur de chimie en francais pour cours et TP, avec saisie simple, resultat rapide et interpretation claire.";
const KEYWORDS =
  "density calculator, calculatrice chimie, formule de chimie, tp de chimie, calcul en ligne";
const OG_URL =
  "https://do-calculate.com/calculator/fr/density-calculator/";
function DensityCalculator() {
  const [mass, setMass] = useState("");
  const [volume, setVolume] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const handleCalculate = () => {
    try {
      if (!mass || !volume) {
        setError("Veuillez entrer masse et volume");
        setResult(null);
        return;
      }
      const m = parseFloat(mass);
      const v = parseFloat(volume);
      if (m <= 0 || v <= 0) {
        setError("Les valeurs doivent être positives");
        setResult(null);
        return;
      }
      const density = m / v;
      setResult(density.toFixed(4));
      setError("");
    } catch (err) {
      setError("Erreur lors du calcul");
      setResult(null);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  La calculatrice de densité calcule la densité d'une substance.
                  Formule: Densité = Masse / Volume. La densité mesure la masse par unité de volume
                  et est exprimée en g/cm³ ou kg/m³.
                </p>
                <ul>
                  <li>Calcul de densité instantané</li>
                  <li>Utile pour les sciences physiques</li>
                  <li>Comparaison des matériaux</li>
                </ul>
                <hr />
              </div>
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Masse (g)
                      </label>
                      <input
                        type="number"
                        value={mass}
                        onChange={(e) => setMass(e.target.value)}
                        placeholder="Entrez la masse"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2">
                        Volume (cm³)
                      </label>
                      <input
                        type="number"
                        value={volume}
                        onChange={(e) => setVolume(e.target.value)}
                        placeholder="Entrez le volume"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  {error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result && (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultat:</h4>
                      <p>
                        Densité = <strong>{result} g/cm³</strong>
                      </p>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comment calculer la densite</h3></div>
              <div className="info-section-body">
                <p>Entrez la masse puis le volume de l'echantillon dans les memes unites de reference. La calculatrice applique directement la formule densite = masse / volume et retourne un resultat exploitable en g/cm³.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>A quoi sert la densite en chimie</h3></div>
              <div className="info-section-body">
                <p>La densite permet d'identifier des substances, de comparer des materiaux et de verifier des mesures experimentales. C'est une grandeur de base tres utilisee dans les TP et les exercices de chimie physique.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils de precision</h3></div>
              <div className="info-section-body">
                <p>Assurez-vous que la masse et le volume sont mesures a la meme temperature et avec des instruments calibres. Des ecarts de mesure minimes peuvent impacter fortement la densite finale.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default DensityCalculator;
